import React from 'react';
import {ContainerFileDinhKem} from 'components/upload';
import {Text} from 'components/tt-forms/common';

class DinhChiView extends React.Component {

  render() {

    return (
      <div className="row pl15 pr15 pt10 wrap-block">
        <div className="txt-bold text-14 mb15 txt-blue txt-upper">{this.props.ma == '' ? 'Rút đơn' : 'Đình chỉ'}</div>
        <div className="row pl10 pr10 mb10">
          <Text className="col-100 mb5" label={this.props.ma == ''? 'Lý do rút đơn' : 'Lý do đình chỉ'} value={this.props.lyDoDinhChi} />
          <div className="col-100 pb5 container-filedinhkem">
            <ContainerFileDinhKem label="Danh sách văn bản xử lý" hideDescription={true} bindValidator={this}
              dataShow={ (this.props.processType == 'XU_LY_DON' ? this.props.listTaiLieuVanThu : this.props.listTaiLieuVanThuGiaiQuyetDon)} disableAttachFile={true} />
          </div>
        </div>
      </div>
    );
  }
}

export default DinhChiView;


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-dinh-chi/DinhChiView.jsx